import { reducer as supervisorDelivery } from "./detail/slice";

export const reducer = {
  supervisorDelivery,
};
